import React, { useState } from "react";
import {
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Box,
  Popover,
  Typography,
} from "@mui/material";
import CustomEditActionButtons from "./EditActionButtons";

function EditRowDialog({
  table,
  row,
  initialData,
  openSnackbar,
  setUpdateStatus,
}) {
  const [newRow, setNewRow] = useState({
    material_id: initialData.material_id || "",
    material_name: initialData.material_name || "",
    material_description: initialData.material_description || "",
    default_unit: initialData.default_unit || "",
  });
  const handleInputChange = (field, value) => {
    setNewRow((prev) => ({ ...prev, [field]: value }));
  };
  return (
    <>
      <DialogTitle
        variant="h5"
        sx={{ fontSize: "18px !important", color: "#111" }}
      >
        자재정보 수정
      </DialogTitle>
      <DialogContent
        sx={{ display: "flex", flexDirection: "column", gap: "1.5rem" }}
      >
        <TextField
          label="자재 명"
          value={newRow.material_name}
          name="material_name"
          onChange={(e) => handleInputChange("material_name", e.target.value)}
          fullWidth
        />
        <TextField
          label="단위"
          value={newRow.default_unit}
          name="default_unit"
          onChange={(e) => handleInputChange("default_unit", e.target.value)}
          fullWidth
        />
        <TextField
          label="자재 설명"
          fullWidth
          name="material_description"
          value={newRow.material_description}
          onChange={(e) =>
            handleInputChange("material_description", e.target.value)
          }
        />
      </DialogContent>
      <DialogActions>
        {/* <ActioButtons variant="text" table={table} row={row} /> */}
        <CustomEditActionButtons
          table={table}
          row={row}
          openSnackbar={openSnackbar}
          newRow={newRow}
          setUpdateStatus={setUpdateStatus}
        />
      </DialogActions>
    </>
  );
}

export default EditRowDialog;
